import { api } from './client';
import type { SideGameClaim, SideGameKind } from './types';

type ClaimResponse = { kind: SideGameKind; claims: SideGameClaim[] };

export const sidegamesApi = {
  claimKp: (eventId: string, holeNumber: number, participantId?: string) =>
    api.post<ClaimResponse>(
      `/events/${eventId}/holes/${holeNumber}/kp`,
      participantId ? { participantId } : {},
    ),
  claimLd: (eventId: string, holeNumber: number, participantId?: string) =>
    api.post<ClaimResponse>(
      `/events/${eventId}/holes/${holeNumber}/ld`,
      participantId ? { participantId } : {},
    ),
  claimHio: (eventId: string, holeNumber: number, participantId?: string) =>
    api.post<ClaimResponse>(
      `/events/${eventId}/holes/${holeNumber}/hio`,
      participantId ? { participantId } : {},
    ),
  deleteKp: (eventId: string, holeNumber: number, claimId: string) =>
    api.del<ClaimResponse>(`/events/${eventId}/holes/${holeNumber}/kp/${claimId}`),
  deleteLd: (eventId: string, holeNumber: number, claimId: string) =>
    api.del<ClaimResponse>(`/events/${eventId}/holes/${holeNumber}/ld/${claimId}`),
  deleteHio: (eventId: string, holeNumber: number, claimId: string) =>
    api.del<ClaimResponse>(`/events/${eventId}/holes/${holeNumber}/hio/${claimId}`),
  promoteKp: (eventId: string, holeNumber: number, claimId: string) =>
    api.post<ClaimResponse>(`/events/${eventId}/holes/${holeNumber}/kp/${claimId}/promote`),
  promoteLd: (eventId: string, holeNumber: number, claimId: string) =>
    api.post<ClaimResponse>(`/events/${eventId}/holes/${holeNumber}/ld/${claimId}/promote`),
};
